module.exports = __webpack_public_path__ + "f6c674d011f1a2c348886fcb136c20b1.pdf";